import { createContext } from 'react';
import { TableKeys as Tab } from '../../../models';
import { AudienceGraphql, AudienceRuleGraphql } from '../../../../generated/apollo-hooks';

export interface ICreateAudienceDialogContext {
    dataTestId: string;
    audience: Pick<AudienceGraphql, 'title' | 'description'> & Partial<AudienceGraphql>;
    redirectToNotification: (tab: Tab) => Promise<void>;
    rules: AudienceRuleGraphql[];
    editMode: boolean;
}

export const CreateAudienceDialogContext = createContext<Partial<ICreateAudienceDialogContext>>({});
